import { render } from "./SoilConsulting.vue?vue&type=template&id=b112349c"
import script from "./SoilConsulting.vue?vue&type=script&lang=js"
export * from "./SoilConsulting.vue?vue&type=script&lang=js"

import "./SoilConsulting.vue?vue&type=style&index=0&id=b112349c&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__